import { paths as CustomerCommunicationPaths } from '@luxuryescapes/contract-customer-communication';

import { FORM_TYPE_CUSTOM } from '~/consts/customerCommunication/heroPlanner';

import { request } from '~/services/common';

import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';

type HeroPlannerScheduleEmailStatusPutContract =
  CustomerCommunicationPaths['/api/customer-communication/v1/todays-escapes-schedule/hero-planner/schedules/{scheduleId}/email/status/{statusId}']['put'];

async function requestPutHeroPlannerScheduleEmailStatus(
  scheduleId: HeroPlannerScheduleEmailStatusPutContract['parameters']['path']['scheduleId'],
  statusId: HeroPlannerScheduleEmailStatusPutContract['parameters']['path']['statusId'],
  formType?: string,
) {
  if (!scheduleId) {
    throw 'missing scheduleId';
  }
  if (!statusId) {
    throw 'missing statusId';
  }

  const url = makeCustomerCommunicationV1URL(
    `/todays-escapes-schedule/hero-planner/schedules/${scheduleId}/email/status/${statusId}`,
  );
  if (formType?.toUpperCase() === FORM_TYPE_CUSTOM) {
    url.searchParams.set('type', FORM_TYPE_CUSTOM);
  }

  return request(url.toString(), {
    method: 'PUT',
    credentials: 'include',
  })
    .then((response: HeroPlannerScheduleEmailStatusPutContract['responses']['200']['content']['application/json']) => {
      return response.result.emailStatus;
    })
    .catch((error) => {
      throw JSON.stringify(error, null, 2);
    });
}

export default requestPutHeroPlannerScheduleEmailStatus;
